import * as fromDatatype from "../../../../models/datatype-library";

export class TripSearchDto {
    trip_guids: any[];
    delivery_region_guids: any[];
    vehicle_guids: any[];
    start_date_from: fromDatatype.TimestampTzDatatypeInterface;
    start_date_to: fromDatatype.TimestampTzDatatypeInterface;
    end_date_from: fromDatatype.TimestampTzDatatypeInterface;
    end_date_to: fromDatatype.TimestampTzDatatypeInterface;
    delivery_status: any[];
    delivery_logic: any[];
    process_hdr_guids: any[];
    search_keyword: any[];
}